<ng-container *transloco="let t">
    @if (!showHelpText) {
    <section>
        <h1>{{ t("auth.account-setup.header") }}</h1>
        <form [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
            <input
                type="hidden"
                [value]="
                    $safeNavigationMigration(
                        formGroup.get('receivesNotifications')?.value
                    )
                "
                value="true"
            />
            <mat-form-field appearance="outline">
                <mat-label>{{ t("auth.account-setup.firstName") }}</mat-label>
                <input matInput formControlName="firstName" maxlength="50" />
                @if (firstName?.hasError('required')) {
                <mat-error>
                    {{ t("auth.account-setup.firstNameRequired") }}
                </mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>{{ t("auth.account-setup.lastName") }}</mat-label>
                <input matInput formControlName="lastName" maxlength="50" />
                @if (lastName?.hasError('required')) {
                <mat-error>
                    {{ t("auth.account-setup.lastNameRequired") }}
                </mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>{{
                    t("auth.account-setup.emailOrPhone")
                }}</mat-label>
                <input
                    matInput
                    formControlName="emailOrPhone"
                    maxlength="200"
                />
                @if (emailOrPhone?.hasError('required')) {
                <mat-error>
                    {{ t("auth.account-setup.emailOrPhoneRequired") }}
                </mat-error>
                } @if (emailOrPhone?.hasError('email')) {
                <mat-error>
                    {{ t("auth.account-setup.emailInvalid") }}
                </mat-error>
                } @if (emailOrPhone?.hasError('invalidPhoneNumber')) {
                <mat-error>
                    {{ t("auth.account-setup.phoneInvalid") }}
                </mat-error>
                }
            </mat-form-field>
            <small
                [innerHTML]="$safeNavigationMigration(client?.signUpFooterHtml)"
            ></small>
            <mat-checkbox formControlName="agree">
                {{ t("auth.account-setup.agreementLabel.1") }}
                <a href="javascript:void(0)" (click)="displayInfo('terms')">{{
                    t("shared.link.terms-of-use")
                }}</a>
                {{ t("auth.account-setup.agreementLabel.2") }}
                <a href="javascript:void(0)" (click)="displayInfo('privacy')">{{
                    t("shared.link.privacy-policy")
                }}</a
                >. @if (agree?.hasError('required') && agree?.touched) {
                <mat-error>
                    {{ t("auth.account-setup.agreementRequired") }}
                </mat-error>
                }
            </mat-checkbox>
            @if (submitFailed) {
            <mat-error class="submit-failed">
                {{ t("shared.error.submitFailed") }}
            </mat-error>
            }
            <div class="actions">
                <button
                    type="button"
                    mat-button
                    [disabled]="busy"
                    (click)="goBack()"
                >
                    <mat-icon color="accent">arrow_back</mat-icon>
                    {{ t("shared.go-back") | uppercase }}
                </button>
                <app-busyable-button
                    [disabled]="formGroup.invalid"
                    [busy]="busy"
                    [text]="t('shared.continue') | uppercase"
                ></app-busyable-button>
            </div>
        </form>
    </section>
    } @else {
    <section class="service-unavailable">
        @if (displayTerms) {
        <app-terms-of-use></app-terms-of-use>
        } @if (displayPrivacy) {
        <app-privacy-policy></app-privacy-policy>
        }
        <button type="button" mat-button (click)="goBackPrevious()">
            <mat-icon color="accent">arrow_back</mat-icon>
            {{ t("shared.go-back") | uppercase }}
        </button>
    </section>
    }
</ng-container>
